export interface Dropdown {
  value: string | number,
  displayValue: string
};

export const activeStatus: Dropdown[] = [
  {displayValue: 'Tous', value: 'all'},
  {displayValue: 'Oui', value: 'true'},
  {displayValue: 'Non', value: 'false'}
];

export const subscriptionTypes: Dropdown[] = [
  {displayValue: 'Tous', value: 'all'},
  {displayValue: 'Classique', value: 'AbonneClassique'},
  {displayValue: 'Premium', value: 'AbonnePremium'},
  {displayValue: 'Etudiant', value: 'AbonneEtudiant'},
  {displayValue: 'Legacy', value: 'AbonneLegacy'},
];

export const monthsAbbrev = ['JAN', 'FEV', 'MAR', 'AVR', 'MAI', 'JUN', 'JUL', 'AOU', 'SEP', 'OCT', 'NOV', 'DEC'];

export const currentYear = new Date().getFullYear()

export const stripeStatYears: Dropdown[] = new Array((currentYear + 1) - 2021)
  .fill(1)
  .map((_, index) => {
    const year = 2021 + index
    return { displayValue: String(year), value: year }
  });

export const stripeStatDefaultYear = stripeStatYears[stripeStatYears.length - 1].value

export const ogoneStatYears: Dropdown[] = new Array(2023 - 2014)
  .fill(1)
  .map((_, index) => {
    const year = 2014 + index
    return { displayValue: String(year), value: year }
  });

export const ogoneStatDefaultYear = ogoneStatYears[ogoneStatYears.length - 1].value

type statRecord = { date: string, value: number }

export interface StatByProfitwell {
  active_customers: statRecord[]
  active_trialing_customers: statRecord[]
  average_revenue_per_user: statRecord[]
  churned_customers: statRecord[]
  churned_customers_cancellations: statRecord[]
  churned_customers_delinquent: statRecord[]
  churned_recurring_revenue: statRecord[]
  churned_recurring_revenue_cancellations: statRecord[]
  churned_recurring_revenue_delinquent: statRecord[]
  churned_trialing_customers: statRecord[]
  converted_customers: statRecord[]
  converted_recurring_revenue: statRecord[]
  customer_conversion_rate: statRecord[]
  customers_churn_cancellations_rate: statRecord[]
  customers_churn_delinquent_rate: statRecord[]
  customers_churn_rate: statRecord[]
  customers_retention_rate: statRecord[]
  downgrade_rate: statRecord[]
  downgraded_customers: statRecord[]
  downgraded_recurring_revenue: statRecord[]
  existing_customers: statRecord[]
  existing_recurring_revenue: statRecord[]
  existing_trialing_customers: statRecord[]
  growth_rate: statRecord[]
  lifetime_value: statRecord[]
  new_customers: statRecord[]
  new_recurring_revenue: statRecord[]
  new_trialing_customers: statRecord[]
  reactivated_customers: statRecord[]
  reactivated_recurring_revenue: statRecord[]
  recurring_revenue: statRecord[]
  revenue_churn_cancellations_rate: statRecord[]
  revenue_churn_delinquent_rate: statRecord[]
  revenue_churn_rate: statRecord[]
  revenue_retention_rate: statRecord[]
  saas_quick_ratio: statRecord[]
  trial_conversion_time: statRecord[]
  upgrade_rate: statRecord[]
  upgraded_customers: statRecord[]
  upgraded_recurring_revenue: statRecord[]
  [key: string]: statRecord[]
}